export default "__VITE_ASSET__BFTk3jv7__"